import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, NgZone } from '@angular/core';
import { LayoutService } from '../layout/layout.service';
import { BrandAllocation } from '../../client-core/dtos/brand-allocation.models';
import { BrandService } from '../../client-core/services/brand.service';
import { ValidationMessage } from 'app/validation';
import { ChangeDriver, ChangeIndicator } from 'app/client-core/dtos/change-driver.model';
import { CommunicationRequestDto, NewCommunicationRequestDto } from '../../client-core/dtos/communication-request.model';
import { Observable } from 'rxjs';
import { ProgramService } from 'app/client-core/services/program.service';
import { DropzoneComponent, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { ApiService } from 'app/client-core/api.service';
import * as moment from 'moment';
import { NotificationService } from '../utils/notification.service';
import { RetailerProfileDocDto } from 'app/client-core/dtos/retailers.model';
const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  maxFilesize: 50,
  acceptedFiles: '*'
};

@Component({
  selector: 'retailer-profile-approval-request',
  templateUrl: './retailer-profile-approval-request.component.html',
  styleUrls: ['./retailer-profile-approval-request.component.scss']
})
export class RetailerProfileApprovalRequestComponent implements OnInit, OnChanges {
  @Input() requestId: number;
  ready: boolean;
  @Input() dto: RetailerProfileDocDto;
  validationMessages: any;
  submitted: boolean;
  items: any[] = [];
  contactitems: any[] = [];
  columns = Observable.of([
    { prop: "id", name: "Id", flexGrow: 1 },
    { prop: "name", name: "Name", flexGrow: 3 },
  ]);
  config: any;
  currentDate=moment().toDate();
  saving: boolean;

  constructor(
    private layoutService: LayoutService,
    public programService: ProgramService,
    private zone: NgZone,
    private apiService: ApiService,
    private notificationService: NotificationService
  ) {
    
  }

  ngOnInit(): void {
    this.ready = true;
  }

  onUploadSuccess() {

  }

  onUploadError() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    
  }

  closeModal() {
    this.contactitems = [];
    this.submitted = false;
    this.layoutService.hideSideModal.next();
  }

  canSubmit() {
    return true;
  }

  onSubmit() {
    this.submitted = false;
    this.saving = true;
    if (!this.canSubmit()) {
      this.validationMessages = new ValidationMessage(null, true, "There are some validation errors.");
      this.submitted = true;
      this.saving = false;
      return;
    }

    this.notificationService.smartMessageBox({
      title: "",
      content: `Are you sure you want to send this to approval?`,
      buttons: '[No][Yes]'

    }, (ButtonPressed) => {
        if (ButtonPressed == "Yes") {
          this.programService.markCommunicationAsResolved({
            action: 'RequestApproval',
            requestId: this.requestId
          }).subscribe(() => {
            this.closeModal();
            this.validationMessages = new ValidationMessage(null, true, "Approval Requested.").isSuccess();
          })
        }
    });
  }

  contactsRowSelected(event) {
    if (this.contactitems && !this.contactitems.find(c => c.id == event.item.id)) {
      this.contactitems.push(event.item);
      this.updateContact(event.item.id, 1);
    }
  }

  contactsRemoveRowSelected(event) {
    this.contactitems = this.contactitems.filter(c => c.id != event.id);
    this.updateContact(event.id, 0);
  }

  updateContact(contactId, isSelected) {
    this.programService.updateContacts({
      requestId: this.requestId,
      contactId,
      isSelected: isSelected ? 1 : 0
    }).subscribe(() => {
      
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/retailer-profile-approval-request/retailer-profile-approval-request.component.ts